module.exports = __webpack_public_path__ + "static/media/search-icon.6ca20b7b.svg";